import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'page-patient',
  templateUrl: './home-patient.component.html',
  styleUrls: ['./home-patient.component.scss'],
})
export class HomePatientComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit(): void {}

  goToUrl(page: string) {
    this.router.navigate([page]);
  }
}
